import { COUNTRIES } from '@config/constants'
import { dynamicImport } from '@core/helpers'
import minimalLayout from '@core/layouts/minimal.vue'
import { ROUTES } from '@router'

const buybackEligibleCountries = [COUNTRIES.FR, COUNTRIES.DE, COUNTRIES.US]

export const buybackRefurbisherMinimalLayoutRoutes = ({ country }) => {
  if (buybackEligibleCountries.includes(country)) {
    return [
      {
        path: '/bo_merchant/buyback/orders/:id/conversation',
        component: minimalLayout,
        meta: {
          auth: {
            required: true,
            redirection: { name: ROUTES.BO_MERCHANT.LOGIN },
          },
          seller: {
            required: true,
            redirection: { name: ROUTES.BO_MERCHANT.LOGIN },
          },
        },
        children: [
          {
            name: ROUTES.BUYBACK.REFURBISHER.CONVERSATION,
            path: '',
            component: () =>
              dynamicImport(
                import('@buyback/refurbisher/orders/pages/OrderConversation'),
              ),
          },
        ],
      },
    ]
  }

  return []
}

export const buybackCustomerMinimalLayoutRoutes = ({ country }) => {
  if (buybackEligibleCountries.includes(country)) {
    return [
      {
        path: 'dashboard/sales/:id/conversation',
        component: minimalLayout,
        meta: {
          auth: {
            required: true,
            redirection: { name: ROUTES.AUTH.REGISTER },
          },
        },
        children: [
          {
            name: ROUTES.BUYBACK.CUSTOMER.DASHBOARD.CONVERSATION,
            path: '',
            component: () =>
              dynamicImport(
                import('@buyback/customer/dashboard/pages/SaleConversation'),
              ),
          },
        ],
      },
    ]
  }

  return []
}
